import {
    createPrizeItem,
    deletePrizeItem,
    getPrizeItem,
    getPrizeItemList,
    updatePrizeItem,
} from '../../services/api/prizeApi';
import {
    CLOSE_PRIZE_EDITOR,
    CREATE_PRIZE_ITEM,
    DELETE_PRIZE_ITEM,
    GET_PRIZE_ITEM,
    GET_PRIZE_ITEMS,
    OPEN_PRIZE_EDITOR,
    UPDATE_EDITOR_FIELD,
    UPDATE_PRIZE_ITEM,
} from './actionTypes';
import { hideLoading, showLoading } from './loadingActions';
import { clearMerchantInfo } from './merchantActions';
import { notifyError, notifySuccess } from './notificationActions';

export const createPrizeAction = (prizeItem) => {
    return {
        type: CREATE_PRIZE_ITEM,
        prizeItem,
    };
};

export const getPrizeAction = (prize) => {
    return {
        type: GET_PRIZE_ITEM,
        prize,
    };
};
export const getPrizeItemsAction = (prizeItems) => {
    return {
        type: GET_PRIZE_ITEMS,
        prizeItems,
    };
};
export const updatePrizeItemAction = (prizeItem) => {
    return {
        type: UPDATE_PRIZE_ITEM,
        prizeItem,
    };
};
export const deletePrizeItemAction = (id) => {
    return {
        type: DELETE_PRIZE_ITEM,
        id,
    };
};

export const openPrizeEditor = (id) => {
    return {
        type: OPEN_PRIZE_EDITOR,
        id,
    };
};
export const closePrizeEditor = () => {
    return {
        type: CLOSE_PRIZE_EDITOR,
    };
};
export const updateEditorField = (field, value) => {
    return {
        type: UPDATE_EDITOR_FIELD,
        field,
        value,
    };
};

export function createPrize(prize) {
    return function (dispatch, getState) {
        const { auth } = getState();
        const { market, category, brand } = auth?.user;

        return Promise.resolve()
            .then(() => dispatch(showLoading()))
            .then(() => createPrizeItem(market, category, brand, prize))
            .then((result) => dispatch(createPrizeAction(result.data)))
            .then(() => dispatch(closePrizeEditor()))
            .then(() => dispatch(clearMerchantInfo()))
            .then(() => dispatch(notifySuccess('Success', 'Prize created successfully')))
            .catch((error) => dispatch(notifyError('Error', 'Unable to create the prize')))
            .finally(() => dispatch(hideLoading()));
    };
}

export function getPrizeList() {
    return function (dispatch, getState) {
        const { auth } = getState();
        const { market, category, brand } = auth?.user;

        return Promise.resolve()
            .then(() => dispatch(showLoading()))
            .then(() => getPrizeItemList(market, category, brand))
            .then((result) => dispatch(getPrizeItemsAction(result.data)))
            .catch((error) => dispatch(notifyError('Error', 'Unable to retrive prize list')))
            .finally(() => dispatch(hideLoading()));
    };
}

export function getPrize(prizeId) {
    return function (dispatch, getState) {
        const { auth } = getState();
        const { market, category, brand } = auth?.user;

        return Promise.resolve()
            .then(() => dispatch(showLoading()))
            .then(() => getPrizeItem(market, category, brand, prizeId))
            .then((result) => dispatch(getPrizeAction(result.data)))
            .catch((error) => dispatch(notifyError('Error', 'Unable to retrive the prize')))
            .finally(() => dispatch(hideLoading()));
    };
}

export function renderPrizeEditor(prizeId) {
    return function (dispatch, getState) {
        return Promise.resolve()
            .then(() => dispatch(getPrize(prizeId)))
            .then(() => dispatch(openPrizeEditor(prizeId)))
            .catch((err) => dispatch(notifyError('Error', 'Unable to open the prize')));
    };
}

export function updatePrize(id, body) {
    return function (dispatch, getState) {
        const { auth } = getState();
        const { market, category, brand } = auth?.user;

        return Promise.resolve()
            .then(() => dispatch(showLoading()))
            .then(() => updatePrizeItem(market, category, brand, id, body))
            .then((result) => updatePrizeItemAction(result.data))
            .then(() => dispatch(closePrizeEditor()))
            .then(() => dispatch(clearMerchantInfo()))
            .then(() => dispatch(notifySuccess('Success', 'Prize updated successfully')))
            .catch((err) => dispatch(notifyError('Error', 'Unable to update the prize')))
            .finally(() => dispatch(hideLoading()));
    };
}

export function deletePrize(id) {
    return function (dispatch, getState) {
        const { auth } = getState();
        const { market, category, brand } = auth?.user;

        return Promise.resolve()
            .then(() => dispatch(showLoading()))
            .then(() => deletePrizeItem(market, category, brand, id))
            .then(() => dispatch(deletePrizeItemAction(id)))
            .then(() => dispatch(closePrizeEditor()))
            .then(() => dispatch(clearMerchantInfo()))
            .then(() => dispatch(notifySuccess('Success', 'Prize deleted successfully')))
            .catch((err) => dispatch(notifyError('Error', 'Unable to delete the prize')))
            .finally(() => dispatch(hideLoading()));
    };
}

export function updateField(field, value) {
    return function (dispatch, getState) {
        dispatch(updateEditorField(field, value));
        const { merchant } = getState();
        const { merchantInfo, denominations } = merchant;
        if (field === 'merchantId') {
            dispatch(
                updateEditorField('merchantName', merchantInfo?.merchantName)
            );
            // merchant changed → drop the previous merchant's denomination selection
            dispatch(updateEditorField('denominationId', ''));
            dispatch(updateEditorField('denominationValue', ''));
            dispatch(updateEditorField('denominationQuantity', ''));
        }
        if (field === 'denominationId') {
            const denomination = denominations.find(
                (d) => d?.denominationId === value
            );
            const denominationValue = denomination?.denominationValue;
            dispatch(updateEditorField('denominationValue', denominationValue));
        }
    };
}
